<template>
  <div>
    <OpisBlockShow
      :card="card"
      :showEditLink="showEditLink"
      :toggleAction="toggleEditMode"
      :saveDataColumns="saveDataColumns"
      :saveDataParams="saveDataParams"
      v-show="!editMode"
    ></OpisBlockShow>

    <OpisBlockEdit
      :card="card"
      :saveDataColumns="saveDataColumns"
      :saveDataParams="saveDataParams"
      :toggleAction="toggleEditMode"
      v-show="editMode"
    ></OpisBlockEdit>
  </div>
</template>

<script>
import OpisBlockShow from "@/components/card/OpisBlockShow.vue";
import OpisBlockEdit from "@/components/card/OpisBlockEdit.vue";

export default {
  props: {
    card: { type: Object, default: function() { return {}; } },
    showEditLink: { type: Boolean, default: function() { return false; } },
    saveDataColumns: Function,
    saveDataParams: Function,
  },
  components: {
    OpisBlockShow, OpisBlockEdit
  },
  data() {
    return {
      editMode: false
    };
  },
  methods: {
    toggleEditMode() {
      this.editMode = !this.editMode;
      console.log('Card component toggleEditMode', this.editMode);
    },
  }
};
</script>
